import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { appRoutes } from "routes";
import { DATE_TYPE_QUERIES, FACE_PAGE_FLOWS } from "enums";
import { useFaces, useRouter } from "hooks";
import AlgoliaSearchWrapper from "components/AlgoliaSearchWrapper";
import PersonPresenter from "presenters/PersonPresenter";
import FacePresenter from "presenters/FacePresenter";

import SearchBox from "./components/SearchBox";

const AlgoliaCalendar = ({ person, dateType, dateToCelebrate, onClose }) => {
  const { setFaceToAddJaw, setPhoto, setMode } = useFaces();
  const { pushWithSave } = useRouter();
  const face = PersonPresenter.defaultHead(person);

  useEffect(() => {
    if (!FacePresenter.jaw(face)) {
      setFaceToAddJaw(face);
      setPhoto(FacePresenter.asset(face));
      setMode(FACE_PAGE_FLOWS.JAW_CUT_MISSING);
      pushWithSave(appRoutes.facePath());
    }
  }, []);

  return (
    <AlgoliaSearchWrapper>
      <SearchBox
        defaultRefinement={DATE_TYPE_QUERIES[dateType]}
        person={person}
        dateType={dateType}
        dateToCelebrate={dateToCelebrate}
        onClose={onClose}
      />
    </AlgoliaSearchWrapper>
  );
};

AlgoliaCalendar.propTypes = {
  person: PersonPresenter.shape().isRequired,
  dateType: PropTypes.string.isRequired,
  dateToCelebrate: PropTypes.string,
  onClose: PropTypes.func,
};

export default AlgoliaCalendar;
